import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';

interface IProps {
  vat_rate_id: number;
  vat_rate_type_id: number;
  country_code: string;
  country_name: string;
  vat_rate: number;
  valid_from: string;
  valid_to: string | null;
}

export default function ActionsBlock(props: IProps) {
  const dispatch = useDispatch();

  const openEdit = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_EDIT_VAT_RATE,
        params: {
          vat_rate_id: props.vat_rate_id,
          vat_rate_type_id: props.vat_rate_type_id,
          country_code: props.country_code,
          country_name: props.country_name,
          vat_rate: props.vat_rate,
          valid_from: props.valid_from,
          valid_to: props.valid_to,
        },
      })
    );
  };

  return (
    <div>
      <Button onClick={openEdit}>Edit</Button>
    </div>
  );
}
